import { createFileRoute, redirect } from '@tanstack/react-router'

// Breach monitoring consolidated onto /footprint (the "Breach Monitor") in
// the 2026-06 IA cleanup (TD-016). Breach detail pages
// (/data-breaches/$breachId) are unaffected.
export const Route = createFileRoute('/_auth/data-breaches/')({
  beforeLoad: () => {
    throw redirect({ to: '/footprint', replace: true })
  },
})
